// 开发过程中暂无接口时在此构建所需数据(构造的数据请做好备注，么么哒~)

// BOMS 6.0 账号管理->账号列表
// const accountList = [{}]

const data = {

// BOMS 6.0 账号管理->组织结构数据
organizationList: [{name:'运营商【示例1】',code:0,children:[{name:'品牌xxx',code:1,parentCode:0,children:[{name:'华南区域',code:2,parentCode:1,children:[{name:'广州市',code:5,parentCode:2,children:[{name:'越秀区',code:9,parentCode:5,children:[{name:'测试门店1',code:11,parentCode:9}]},{name:'荔湾区',code:10,parentCode:5,children:[{name:'测试门店2',code:12,parentCode:10}]}]},{name:'深圳',code:6,parentCode:2,children:[]}]},{name:'华北区域',code:3,parentCode:1,children:[{name:'北京',code:7,parentCode:3,children:[]}]},{name:'华中区域',code:4,parentCode:1,children:[{name:'上海',code:8,parentCode:3,children:[]}]}]}]}]

// BOMS 6.0 账号管理->账号列表
,accountList: [{}]

// 获取门店繁忙状态
,storeStatus: {
  // 获取门店各渠道繁忙
  clientTypeStatus: [
    {status: true, name: '饿了么', reason: '餐厅人手不足', time: '2017-12-12 22:00'},
    {status: true, name: '美团', reason: '餐厅人手不足', time: '2017-12-12 22:00'},
    {status: false, name: '百度', reason: '餐厅人手不足', time: '2017-12-12 22:00'},
    {status: false, name: 'H5', reason: '餐厅人手不足', time: '2017-12-12 22:00'},
    {status: false, name: 'Web', reason: '餐厅人手不足', time: '2017-12-12 22:00'}
  ]
  // 获取门店各业务类型繁忙
  ,sendTypeStatus: [
    {status: true,sendType: 1, name: '外卖', reason: '餐厅人手不足', time: '2017-12-12 22:00'},
    {status: true,sendType: 4, name: '外卖预约', reason: '餐厅人手不足', time: '2017-12-12 22:00'},
    {status: false,sendType: 2, name: '自取', reason: '餐厅人手不足', time: '2017-12-12 22:00'},
    {status: false,sendType: 3, name: '堂食', reason: '餐厅人手不足', time: '2017-12-12 22:00'}
  ]
}

// 获取字段排序配置
,columnsSetting: [
  {title : '平台流水号', dataIndex: "sn", isHide : false},
  {title : '第三方流水号', dataIndex: "thirdSn", isHide : false},
  {title : '状态', dataIndex: "statusName", isHide : false},
  {title : '业务类型', dataIndex: "orderTypeName", isHide : false},
  {title : '预送达时间', dataIndex: "sendTime", isHide : false},
  {title : '配送地址', dataIndex: "consigneeAddress", isHide : false},
  {title : '骑手信息', dataIndex: "driverName", isHide : false}
]



}
export default data;


// WEBPACK FOOTER //
// core-build-local/lib/testData/data_boms6.0.js